export default "__VITE_ASSET__YXjaYNHP__"